<template>
  <el-dialog :visible="visible" width="560px" top="5vh" custom-class="order-invoice-dialog"
    :close-on-click-modal="false" :before-close="closeDialog" @open="initialize">
    <div slot="title" class="invoice-dialog-title">
      <span>{{ preview ? '发票详情' : applicationView ? '开票申请详情' : '发票处理' }}</span>
      <el-tag v-if="preview" type="success" size="mini">已上传</el-tag>
      <el-tag v-else-if="applicationView" type="info" size="mini">已申请</el-tag>
    </div>
    <section class="invoice-summary">
      <div class="invoice-summary-heading">
        <span>关联订单 1 笔</span>
        <el-button type="text" @click="expanded = !expanded">{{ expanded ? '隐藏' : '全部展示' }}</el-button>
      </div>
      <div class="invoice-summary-total"><span>订单合计</span><strong>{{ amount }}</strong></div>
      <div v-show="expanded">
        <div class="invoice-order-row invoice-order-header"><span>订单号</span><span>订单金额</span></div>
        <div class="invoice-order-row"><span>{{ invoice.orderNo || '--' }}</span><span>{{ amount }}</span></div>
      </div>
    </section>
    <el-tabs v-model="tab" class="invoice-tabs" :before-leave="canSwitchTab">
      <el-tab-pane :label="applicationSubmitted ? '查看开票' : '申请开票'" name="apply">
        <section v-if="applicationSubmitted" class="invoice-application-details">
          <div class="invoice-upload-label">开票信息</div>
          <div class="invoice-application-content">{{ invoice.invoiceInfo }}</div>
        </section>
        <template v-else>
          <el-form ref="form" :model="form" label-position="top" :rules="rules">
            <el-form-item label="开票信息" prop="invoiceInfo">
              <el-input v-model="form.invoiceInfo" type="textarea" :rows="7" :placeholder="placeholder" />
              <div class="invoice-form-hint">可直接粘贴整段信息，无需逐项填写。</div>
            </el-form-item>
          </el-form>
        </template>
      </el-tab-pane>
      <el-tab-pane :label="savedUrl ? '查看发票' : '上传发票'" name="upload">
        <template v-if="preview">
          <div class="invoice-file-heading"><span>当前发票</span><span class="invoice-muted">1 个文件</span></div>
          <div class="invoice-file-card">
            <span class="invoice-file-type">{{ isPdf ? 'PDF' : isImage ? '图片' : 'OFD' }}</span>
            <div class="invoice-file-description">
              <div :title="fileName">{{ fileName }}</div><small>{{ isPdf ? 'PDF 文件' : isImage ? '图片文件' : 'OFD 文件'
              }}</small>
            </div>
            <el-button type="text" :loading="downloading" @click="downloadInvoice">下载发票</el-button>
          </div>
          <section class="invoice-preview">
            <div class="invoice-preview-heading">发票预览</div>
            <iframe v-if="isPdf" :src="savedUrl" title="发票预览" class="invoice-pdf" />
            <el-image v-else-if="isImage" :src="savedUrl" :preview-src-list="[savedUrl]" fit="contain"
              class="invoice-image">
              <div slot="error" class="invoice-preview-error">无法预览此文件，请下载后查看。</div>
            </el-image>
            <div v-else class="invoice-preview-error">此文件暂不支持在线预览，请下载后查看。</div>
          </section>
        </template>
        <template v-else>
          <div class="invoice-upload-label">发票文件</div>
          <InvoiceFileUpload v-model="form.url" :disabled="submitting" @uploading="uploading = $event" />
          <div class="invoice-form-hint">上传的发票将关联至以上订单。</div>
        </template>
      </el-tab-pane>
    </el-tabs>
    <div slot="footer" class="invoice-footer">
      <el-button :disabled="submitting || uploading" @click="closeDialog">{{ preview || applicationView ? '关闭' : '取消'
      }}</el-button>
      <template v-if="preview">
        <!-- <el-button @click="reupload">重新上传发票</el-button>
        <el-tooltip content="暂未接入发票邮件发送接口" placement="top"><span><el-button type="primary"
              disabled>发送到邮箱</el-button></span></el-tooltip> -->
      </template>
      <el-button v-else-if="!applicationView" type="primary" :loading="submitting" :disabled="uploading"
        @click="submit">
        {{ tab === 'apply' ? '提交申请' : '确认上传' }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import InvoiceFileUpload from './InvoiceFileUpload.vue';
import { orderinvoice, orderuploadinvoice } from '@/api/order';
export default {
  components: { InvoiceFileUpload },
  props: { visible: Boolean, invoice: { type: Object, default: () => ({}) } },
  data() {
    return {
      applicationSubmitted: false, replacing: false, expanded: true, tab: 'apply', savedUrl: '',
      submitting: false, uploading: false, downloading: false,
      form: { invoiceInfo: '', url: '' },
      placeholder: '请在此粘贴完整的开票信息，例如：\n发票抬头：\n纳税人识别号：\n开户银行及账号：\n注册地址及电话：\n接收邮箱：',
      rules: { invoiceInfo: [{ required: true, whitespace: true, message: '请输入开票信息', trigger: 'blur' }] },
    };
  },
  computed: {
    applicationView() { return this.tab === 'apply' && this.applicationSubmitted; },
    preview() { return this.tab === 'upload' && !!this.savedUrl && !this.replacing; },
    amount() { return '¥' + (Number(this.invoice.payableAmount) || 0).toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); },
    isImage() { return /\.(jpe?g|png)(?:[?#]|$)/i.test(this.savedUrl); },
    isPdf() { return /\.pdf(?:[?#]|$)/i.test(this.savedUrl); },
    fileName() {
      try { return decodeURIComponent(this.savedUrl.split(/[?#]/)[0].split('/').pop()) || '发票文件'; }
      catch (error) { return '发票文件'; }
    },
  },
  methods: {
    initialize() {
      this.savedUrl = this.invoice.url || '';
      this.applicationSubmitted = !!this.invoice.applicationSubmitted;
      this.replacing = false;
      this.expanded = true;
      this.tab = 'apply';
      this.uploading = false;
      this.form = { invoiceInfo: this.invoice.invoiceInfo || this.invoice.remark || '', url: '' };
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate());
    },
    canSwitchTab() { return !this.submitting && !this.uploading; },
    closeDialog() {
      if (this.submitting || this.uploading) return;
      this.$emit('update:visible', false);
    },
    reupload() {
      this.replacing = true;
      this.tab = 'upload';
      this.form.url = '';
    },
    async downloadInvoice() {
      if (this.downloading) return;
      this.downloading = true;
      try {
        const response = await fetch(this.savedUrl);
        if (!response.ok) throw new Error('下载失败');
        const url = URL.createObjectURL(await response.blob());
        const link = document.createElement('a');
        link.href = url;
        link.download = this.fileName;
        document.body.appendChild(link);
        link.click();
        link.remove();
        setTimeout(() => URL.revokeObjectURL(url), 1000);
      } catch (error) {
        this.$message.error('下载失败，请稍后重试');
      } finally { this.downloading = false; }
    },
    async submit() {
      if (this.submitting || this.uploading || this.applicationView || this.preview) return;
      if (this.tab === 'apply') {
        const valid = await this.$refs.form.validate().catch(() => false);
        if (!valid) return;
      } else if (!this.form.url) { this.$message.warning('请上传发票'); return; }
      this.submitting = true;
      try {
        const result = this.tab === 'apply'
          ? await orderinvoice({ orderIds: [this.invoice.orderId], customerId: this.invoice.customerId, invoiceInfo: this.form.invoiceInfo, reMarks: '' })
          : await orderuploadinvoice({ orderId: this.invoice.orderId, customerId: this.invoice.customerId, url: this.form.url, remark: this.form.invoiceInfo });
        if (result.code != 1) throw new Error(result.msg || '操作失败');
        this.$message.success('操作成功！');
        this.$emit('refresh');
        this.$emit('update:visible', false);
      } catch (error) { }
      finally { this.submitting = false; }
    },
  },
};
</script>

<style lang="scss">
.el-dialog.order-invoice-dialog {
  max-width: calc(100vw - 32px);
  background: #fff;
  border-radius: 6px;
  overflow: hidden;

  .el-dialog__header {
    display: block !important;
    padding: 24px 24px 20px;
  }

  .el-dialog__title {
    font-size: 18px;
    color: #152238;
  }

  .el-dialog__headerbtn {
    top: 28px;
    right: 24px;
  }

  .el-dialog__body {
    padding: 0 24px 32px;
    background: #fff;
    border-radius: 0;
    color: #152238;
  }

  .invoice-summary {
    padding: 12px 16px 16px;
    background: #f5f7fa;
    border-radius: 4px;
  }

  .invoice-summary-heading,
  .invoice-summary-total,
  .invoice-order-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
  }

  .invoice-summary-heading {
    min-height: 32px;

    .el-button {
      padding: 0;
    }
  }

  .invoice-summary-total {
    padding: 12px 0 16px;
    color: #909399;

    strong {
      font-weight: 400;
      color: #152238;
    }
  }

  .invoice-order-row {
    min-height: 40px;
    border-top: 1px solid #e1e5ed;
    font-size: 16px;

    span:last-child {
      white-space: nowrap;
    }
  }

  .invoice-order-header {
    font-size: 13px;
    color: #909399;
  }

  .invoice-order-list {
    max-height: 200px;
    overflow-y: auto;
  }

  .invoice-tabs {
    margin-top: 12px;
    min-height: 340px;
  }

  .el-tabs__header {
    margin-bottom: 24px;
  }

  .el-tabs__nav-wrap::after {
    height: 1px;
    background: #dfe4ed;
  }

  .el-tabs__item {
    font-weight: 400;
  }

  .el-form-item__label {
    padding-bottom: 8px;
    line-height: 24px;
    color: #303133;
  }

  .el-textarea__inner {
    padding: 12px;
    line-height: 25px;
    min-height: 192px !important;
  }

  .invoice-form-hint {
    margin-top: 6px;
    font-size: 12px;
    line-height: 20px;
    color: #909399;
  }

  .invoice-upload-label {
    margin-bottom: 12px;
  }

  .el-dialog__footer {
    border-top: 1px solid #ebeef5;
    padding: 16px 24px;
  }

  .invoice-footer {
    display: flex;
    justify-content: flex-end;
    gap: 10px;

    .el-button {
      margin-left: 0;
      min-height: 44px;
      padding: 12px 20px;
    }
  }

  .invoice-application-details {
    margin-top: 24px;
    min-height: 280px;
  }

  .invoice-application-content {
    padding: 16px;
    border: 1px solid #dfe4ed;
    border-radius: 4px;
    white-space: pre-wrap;
    overflow-wrap: anywhere;
    line-height: 26px;
  }

  .invoice-dialog-title {
    display: flex;
    align-items: center;
    gap: 12px;
    font-size: 18px;
    color: #152238;
  }

  .invoice-file-heading {
    display: flex;
    justify-content: space-between;
    margin: 24px 0 14px;
  }

  .invoice-muted {
    color: #909399;
    font-size: 12px;
  }

  .invoice-file-card {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 16px;
    border: 1px solid #dfe4ed;
    border-radius: 4px;
  }

  .invoice-file-type {
    flex-shrink: 0;
    padding: 14px 8px;
    border-radius: 4px;
    background: #fff2f0;
    color: #f56c6c;
    font-size: 12px;
  }

  .invoice-file-description {
    min-width: 0;
    flex: 1;

    div {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    small {
      display: block;
      margin-top: 6px;
      color: #909399;
    }
  }

  .invoice-preview {
    margin-top: 16px;
    padding: 16px;
    border-radius: 4px;
    background: #f5f7fa;
  }

  .invoice-preview-heading {
    margin-bottom: 14px;
    font-size: 12px;
    color: #909399;
  }

  .invoice-image {
    display: block;
    width: 100%;
    height: 260px;
    background: white;
  }

  .invoice-pdf {
    display: block;
    width: 100%;
    height: 320px;
    border: 0;
    background: white;
  }

  .invoice-preview-error {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    color: #909399;
  }
}
</style>
